import React from "react";
import { Link } from "react-router-dom";
class LoginBanner extends React.Component {
  render() {
    return (
      <section className="section" style={{ background: "#003557" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center text-white">
                <h2 className="font-weight-normal">Already have an account?</h2>

                <p className="mx-auto text-muted cta-desc mt-4 pt-2">
                  <Link
                    to="/login"
                    className="btn btn-custom-contact btn-rounded"
                  >
                    SIGN IN
                  </Link>
                </p>
                <p className="mx-auto text-white mt-4 pt-2">
                  <i className="mdi mdi-comment-multiple-outline" /> 24/7
                  CUSTOMER SUPPORT /<i className="mdi mdi-email-outline" />{" "}
                  EMAIL US: MIGHTY@MIGHTYWIFI.NET
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default LoginBanner;



// WEBPACK FOOTER //
// ./src/pages/signup/LoginBanner.js